export const isInCampaignTime = (endDate: string): boolean => {
    const todayISOString = new Date().toISOString().slice(0, 10);
    const todayTime = Date.parse(todayISOString);
    const endTime = Date.parse(endDate);

    if (isNaN(todayTime) || isNaN(endTime)) {
        return false;
    }

    return todayTime < endTime;
};
